import { Flex } from '@chakra-ui/react';
import Highlight from '@components/features/Highlight';
import BaseHero from '@components/features/landing-pages/BaseHero';
import Button from '@components/interactive/Button';
import DefaultLayout from '@components/layout/layout/DefaultLayout';
import Body1 from '@components/typography/Body1';
import medicare_card_sleeve from '@public/Medicare_Card_Sleeve.png';
import Image from 'next/image';
import Advisors from '../index/fsm/Advisors';
import BillOfRights from '../index/fsm/BillOfRights';
import CallUs from '../index/fsm/CallUs';
import Clients from '../index/fsm/Clients';
import FAQS from '../index/fsm/FAQS';
import News from '../index/fsm/News';
import Reviews from '../index/fsm/Reviews';
import WhatToExpect from '../index/fsm/WhatToExpect';

const MedicareCardProtector = () => (
  <DefaultLayout>
    <BaseHero
      header="We'll ship you a free Medicare Card Sleeve"
      subheader={() => (
        <Highlight
          text="Seriously. No catch. We protect our clients’ health by helping them find the best plan. We protect your Medicare card with a free sleeve [+]"
          queries={[
            {
              key: 'free sleeve [+]',
              description: <Image src={medicare_card_sleeve} alt="Medicare Card Sleeve" />,
            },
          ]}
          renderText={(text) => <Body1>{text}</Body1>}
        />
      )}
      renderCta={() => (
        <Flex w="100%" maxW="450px">
          <Button
            className="call-us-button"
            href="https://fairsquaremedicare.typeform.com/to/rYRmUZxF"
            width="100%"
            fontSize={18}
            letterSpacing=".5px"
          >
            Get Started
          </Button>
        </Flex>
      )}
    />
    <Reviews />
    <Clients />
    <BillOfRights />
    <WhatToExpect />
    <Advisors />
    <News />
    <FAQS />
    <CallUs />
  </DefaultLayout>
);

export default MedicareCardProtector;
